// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"513":"2b088c38","703":"debfe65c","787":"96a0bc01"}[chunkId] + ".chunk.js";
};